webpackJsonp([245523097761474],{

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/agritech.d6ca8073.jpg";

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ecommerce.62c44241.jpg";

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/geospatial.2781b61d.jpg";

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logistics.fe3c670a.jpg";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/security.5e4d37f9.jpg";

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/telecommunication.143cd7ea.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(86);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _Section = __webpack_require__(6);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _contactCtaBlock = __webpack_require__(11);
	
	var _contactCtaBlock2 = _interopRequireDefault(_contactCtaBlock);
	
	var _pageCover = __webpack_require__(12);
	
	var _pageCover2 = _interopRequireDefault(_pageCover);
	
	var _cover = __webpack_require__(21);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _ecommerce = __webpack_require__(559);
	
	var _ecommerce2 = _interopRequireDefault(_ecommerce);
	
	var _telecommunication = __webpack_require__(563);
	
	var _telecommunication2 = _interopRequireDefault(_telecommunication);
	
	var _logistics = __webpack_require__(561);
	
	var _logistics2 = _interopRequireDefault(_logistics);
	
	var _security = __webpack_require__(562);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _geospatial = __webpack_require__(560);
	
	var _geospatial2 = _interopRequireDefault(_geospatial);
	
	var _agritech = __webpack_require__(558);
	
	var _agritech2 = _interopRequireDefault(_agritech);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Page = function Page() {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(PageCover, null),
	        _react2.default.createElement(PageContent, null)
	    );
	};
	
	exports.default = Page;
	
	
	function PageCover() {
	    return _react2.default.createElement(
	        _pageCover2.default,
	        { image: _cover2.default, slantBottom: 'up' },
	        _react2.default.createElement(
	            _Section2.default,
	            null,
	            _react2.default.createElement(
	                _block2.default,
	                { style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { fontSize: '3em', fontWeight: '400' } },
	                    'We have experience building products for companies in the following industries'
	                )
	            )
	        ),
	        _react2.default.createElement(_contactCtaBlock2.default, null)
	    );
	};
	
	function PageContent() {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _Section2.default,
	            null,
	            _react2.default.createElement(
	                PageItemsContainer,
	                null,
	                _react2.default.createElement(
	                    PageItem,
	                    {
	                        title: 'E-Commerce',
	                        side: 'left',
	                        coverPhoto: _ecommerce2.default,
	                        cta: _react2.default.createElement(
	                            _button.LinkButton,
	                            {
	                                theme: 'accent',
	                                to: '/ecommerce-automation',
	                                size: 'default' },
	                            'Read more'
	                        ) },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We enable online retailers to work better and faster, through a suite of powerful automation tools.'
	                    )
	                ),
	                _react2.default.createElement(PageItem, {
	                    title: 'Logistics',
	                    side: 'right',
	                    coverPhoto: _logistics2.default,
	                    emailRef: 'ws:log' }),
	                _react2.default.createElement(PageItem, {
	                    title: 'Security & law enforcement',
	                    side: 'left',
	                    coverPhoto: _security2.default,
	                    emailRef: 'ws:sec' }),
	                _react2.default.createElement(PageItem, {
	                    title: 'Telecommunications',
	                    side: 'right',
	                    coverPhoto: _telecommunication2.default,
	                    emailRef: 'ws:telco' }),
	                _react2.default.createElement(PageItem, {
	                    title: 'Geospatial',
	                    side: 'left',
	                    coverPhoto: _geospatial2.default,
	                    emailRef: 'ws:geo' }),
	                _react2.default.createElement(PageItem, {
	                    title: 'Agritech',
	                    side: 'right',
	                    coverPhoto: _agritech2.default,
	                    emailRef: 'ws:agri' })
	            )
	        )
	    );
	}
	
	function PageItemsContainer(_ref) {
	    var style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['style']);
	
	    props.style = _extends({
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'flex-start'
	    }, style);
	    return _react2.default.createElement('div', props);
	}
	
	function PageItem(_ref2) {
	    var title = _ref2.title,
	        children = _ref2.children,
	        style = _ref2.style,
	        side = _ref2.side,
	        coverPhoto = _ref2.coverPhoto,
	        cta = _ref2.cta,
	        emailRef = _ref2.emailRef,
	        props = _objectWithoutProperties(_ref2, ['title', 'children', 'style', 'side', 'coverPhoto', 'cta', 'emailRef']);
	
	    var _sideStyle = side === 'left' ? {
	        // Left side
	        alignSelf: 'flex-start'
	    } : {
	        // Right side
	        alignSelf: 'flex-end'
	    };
	
	    var _style = _extends({
	        width: '600px',
	        maxWidth: '100%',
	        padding: '0', // Inner will set padding
	
	        marginBottom: '30px',
	        height: '400px',
	
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'flex-end'
	
	    }, _sideStyle, style);
	
	    if (coverPhoto) {
	        _extends(_style, {
	            backgroundImage: 'url(' + coverPhoto + ')',
	            backgroundPosition: 'center',
	            backgroundSize: 'cover'
	        });
	    }
	
	    var innerStyle = {
	        padding: '60px 40px 40px',
	        background: 'rgba(0, 0, 0, 0.6)',
	        clipPath: 'polygon(\n            0 40px,\n            0 100%,\n            100% 100%,\n            100% 0)'
	    };
	
	    var emailSubject = "Enquiry";
	    if (emailRef) {
	        emailSubject = '[' + emailRef + '] ' + emailSubject;
	    }
	
	    return _react2.default.createElement(
	        _block2.default,
	        _extends({ theme: 'dark', style: _style }, props),
	        _react2.default.createElement(
	            'div',
	            { style: innerStyle },
	            _react2.default.createElement(SplitTitle, {
	                title: title,
	                cta: cta || _react2.default.createElement(ContactCTA, { emailSubject: emailSubject }) }),
	            children
	        )
	    );
	}
	
	PageItem.propTypes = {
	    side: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	    emailRef: _propTypes2.default.string
	};
	
	PageItem.defaultProps = {
	    side: 'left'
	};
	
	function SplitTitle(_ref3) {
	    var title = _ref3.title,
	        cta = _ref3.cta;
	
	    var containerStyle = {
	        display: 'flex',
	        flexDirection: 'row'
	    };
	    return _react2.default.createElement(
	        'div',
	        { style: containerStyle },
	        _react2.default.createElement(
	            'div',
	            { style: { flex: '1' } },
	            _react2.default.createElement(
	                'h2',
	                null,
	                title
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            cta
	        )
	    );
	}
	
	function ContactCTA(props) {
	    return _react2.default.createElement(_button.ContactButton, props);
	}
	
	ContactCTA.defaultProps = {
	    theme: 'accent',
	    children: 'Contact us'
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-industries-index-js-03f222035b737582d72b.js